import { render } from "./UserSignup.vue?vue&type=template&id=6fcf443d&scoped=true"
import script from "./UserSignup.vue?vue&type=script&lang=js"
export * from "./UserSignup.vue?vue&type=script&lang=js"

import "./UserSignup.vue?vue&type=style&index=0&id=6fcf443d&scoped=true&lang=css"

import exportComponent from "../../../../../../../../../Users/kmg/Documents/VS Code/Classwork/poker-session-tracker-vue3/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fcf443d"]])

export default __exports__